(function () {
  const REVIEWS_TARGET_SELECTORS = [
    '#product-reviews',
    '.product-reviews-placeholder',
    '.jdgm-carousel-wrapper',
    '.jdgm-carousel',
    '.jdgm-rev-widg',
    '#product-reviews-carousel',
  ];

  const BADGE_SELECTORS = '.jdgm-preview-badge, .jdgm-prev-badge';

  function getReviewsTarget() {
    for (const selector of REVIEWS_TARGET_SELECTORS) {
      const target = document.querySelector(selector);
      if (target) return target;
    }
    return null;
  }

  function getHeaderOffset() {
    const headerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    return (Number.isFinite(headerHeight) ? headerHeight : 0) + 16;
  }

  function scrollToReviews() {
    const target = getReviewsTarget();
    if (!target) return false;

    const offset = getHeaderOffset();
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  function getScrollLabel() {
    return document.querySelector('product-info')?.dataset.scrollToReviewsLabel || 'Scroll to reviews';
  }

  function enhanceBadge(badge) {
    if (!badge || badge.dataset.reviewsJumpBound === 'true') return;
    if (!getReviewsTarget()) return;

    badge.dataset.reviewsJumpBound = 'true';
    badge.classList.add('product-reviews-jump');
    badge.setAttribute('role', 'button');
    badge.setAttribute('tabindex', '0');

    if (!badge.getAttribute('aria-label')) {
      badge.setAttribute('aria-label', getScrollLabel());
    }
  }

  function enhanceBadges(root = document) {
    root.querySelectorAll(BADGE_SELECTORS).forEach(enhanceBadge);
  }

  function handleBadgeActivate(event) {
    const badge = event.target.closest(BADGE_SELECTORS);
    if (!badge || !badge.classList.contains('product-reviews-jump')) return;

    event.preventDefault();
    scrollToReviews();
  }

  function handleBadgeKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const badge = event.target.closest(BADGE_SELECTORS);
    if (!badge || !badge.classList.contains('product-reviews-jump')) return;

    event.preventDefault();
    scrollToReviews();
  }

  function handleReviewsJumpClick(event) {
    const jumpLink = event.target.closest('a.product-reviews-jump[href="#product-reviews"]');
    if (!jumpLink) return;

    event.preventDefault();
    if (!scrollToReviews()) {
      window.location.hash = 'product-reviews';
    }
  }

  document.addEventListener('click', handleBadgeActivate, true);
  document.addEventListener('click', handleReviewsJumpClick);
  document.addEventListener('keydown', handleBadgeKeydown);

  enhanceBadges();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches?.(BADGE_SELECTORS)) {
          enhanceBadge(node);
          return;
        }
        enhanceBadges(node);
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
